import * as React from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';

import { useApplicationContext } from '@common/react/components/Core/Application/Application';
import { ItemProvider, useItemProviderContext } from '@common/react/components/Core/ItemProvider/ItemProvider';
import ServerPageProvider from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';

import { Page, PagePage } from '@commonTuna/react/objects/Page';

import { useReduxContext } from '@app/hooks/useReduxContext';
import { getPageInfo, getPageShortName } from '@app/components/Utils';
import ShareLinks from '@app/components/UI/ShareLinks/ShareLinks';
import Inquiry from '@app/components/UI/Inquiry/Inquiry';

import banner from '@images/Body_contouring_2.jpeg';
import bannerMobile from '@images/Body_contouring_2_mobile.jpeg';

import '@app/scss/pages/blog.scss';

const ArticleInner: React.FC = () => {
	const { request } = useApplicationContext();

	const { state: { item }, actions: { setItem } } = useItemProviderContext<Page>();

	const location = useLocation();
	const info = getPageInfo(item);
	const name = getPageShortName(item);
	const pages: Array<PagePage> = item.pages.list || [];

	const [skipLoad, setSkipLoad] = React.useState(true);

	const loadArticle = (fullPath) => {
		request<Page>('getBlogArticlePageRemote', {
			fullPath,
		}).then((res) => {
			setItem(res);
		});
	};

	React.useEffect(() => {
		const newPath = location.pathname.slice(1);
		if (!skipLoad && item?.fullPath !== newPath) {
			loadArticle(newPath);
		}
		setSkipLoad(false);
	}, [location.pathname]);

	return <main className="article-page">
		<div className="content-block">
			<div className="extra-text-block" style={{ margin: 0, padding: 0, marginTop: '32px' }}>
				<div className="clearfix">
					<ol className="breadcrumb pull-left">
						<li>
							<Link to="/">Home</Link>
						</li>
						{pages.filter((page) => page.parent.fullPath).map((page) => {
							return <li key={page.id}>
								<Link to={`/${page.parent.fullPath}`}>{getPageShortName(page.parent)}</Link>
							</li>;
						})}
						<li className="active">{name}</li>
					</ol>
				</div>
				<h2>
					{name}
				</h2>
			</div>
			<div className="article">
				{info && info.body
					&& <div dangerouslySetInnerHTML={{ __html: info.body }} />
				}
				{/* item.children && item.children.list?.length > 0 && <div style={{ marginTop: '30px' }}>
					<div className="sub-pages row">
						{item.children.list.map((item) => {
							return <div className="col-lg-3 col-sm-4 col-xs-6" key={item.id}>
								<Link className="sub-page" to={`/${item.fullPath}`}>
									{item.avatar && <div className="sub-page__image" style={{ backgroundImage: getBackgroundUrl(`/remote/${item.avatar}`) }} />}
									<div className="sub-page__name">{getPageShortName(item)}</div>
								</Link>
							</div>;
						})}
					</div>
				</div> */}
				<div className="text-center mt10">
					<div className="line" />
					<ShareLinks />
				</div>
			</div>
		</div>
		<div className="extra-text-block" id="booking" style={{ margin: 0 }}>
			<h2>
				Schedule
			</h2>
			<h3 className="text-center">
				We will get in touch with you as soon as possible
			</h3>
		</div>
		<div className="top-banner" id="home" style={{ maxHeight: '700px' }}>
			<div className="image-block">
				<picture>
					<source media="(max-width: 768px)" srcSet={bannerMobile} />
					<source media="(min-width: 769px)" srcSet={banner} />
					<img className="top-banner__image" alt="banner" srcSet={banner} />
				</picture>
				<div className="content-block">
					<div className="inquiry-form">
						<Inquiry title="" className="inquiry-wrapper-mobile" />
					</div>
				</div>
			</div>
		</div>
	</main>;
};

const Article: React.FC = () => {
	const { blogPageId } = useReduxContext();

	return <>
		{blogPageId > 0
			? (
				<ServerPageProvider
					inner={(serverPage) => (
						<ItemProvider
							id={serverPage.item?.id || 0}
							validationSchema={{}}
							type="page"
							readonly
							loadRequest="getBlogArticlePageRemote"
							item={serverPage?.item}
							skipInitLoad={!!serverPage?.item}
						>
							<ArticleInner />
						</ItemProvider>
					)}
				/>
			)
			: <Navigate to="/" />
		}
	</>;
};

export default Article;
